module.exports = __webpack_public_path__ + "static/media/analysis5.0aff5998.png";